import { buildReducer } from '../../../../shared';
import { CurrentNavigationPersonaState, lpcExpandedViewNavigationAction } from '../../..';

export default buildReducer<CurrentNavigationPersonaState>()
    .handleDataAction(lpcExpandedViewNavigationAction, (_state, action) => {
        // https://msfast.visualstudio.com/FAST/_workitems/edit/250068
        // In the first version we don't honor the contacts of the user
        return { currentPersona: action.payload.persona };
    })
    .done({
        currentPersona: null,
    });
